import { Text } from '@dbi-tools/ui-kit';
import React from 'react';
import { connect } from 'react-redux';
import { ValidationErrorsInterface } from 'react-uforms';

import { currentQuestionsSelector } from '../store/quiz/selectors';
import { RootState } from '../store/root-reducer';
import { Question } from '../types/question';

const FooterText: React.FC<{ footerText: string; errors: ValidationErrorsInterface; currentQuestions: Question[] }> = ({
  footerText,
  errors,
  currentQuestions,
}) => {
  const question = currentQuestions[0];

  const footerLeftText = footerText ? <b>{footerText}</b> : question?.placeholderText;

  let lastError = null;
  if (currentQuestions.length === 1) {
    const plainErrors = errors[question.name];
    lastError = Array.isArray(plainErrors) ? plainErrors.slice(-1)[0] : null;
  }

  return (
    <Text as="div" color="wine" mb={{ xs: 20, lg: 0 }}>
      {lastError ? lastError : footerLeftText || null}
    </Text>
  );
};

const mapStateToProps = (state: RootState) => ({
  footerText: state.quizState.footerText,
  currentQuestions: currentQuestionsSelector(state),
});

export default connect(mapStateToProps)(FooterText);
